var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgForeheadTattoo = function SvgForeheadTattoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 34,
    viewBox: "0 0 0.78 0.96",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2369789925184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.31.09C.59 0 .79.25.68.54.63.68.57.81.47.88.37.94.07.7.07.5.07.29.12.14.31.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.56.3C.5.35.39.34.32.35H.25"
  })))));
};

export default SvgForeheadTattoo;